import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {catchError, map, Observable, of} from "rxjs";
import {DOCUMENT} from "@angular/common";
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  languageOptions = [
    {value: "en", label: "English", height: 15},
    {value: "de", label: "Deutsch", height: 12},
    {value: "fr", label: "Français", height: 12.5},
    {value: "es", label: "Español", height: 15},
    {value: "it", label: "Italiano", height: 15},
    {value: "pt", label: "Português", height: 13},
    {value: "ja", label: "日本語", height: 13},
    // {value: "ar", label: "العربية", height: 13},
  ]

  selectedLang = 'bla';


  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private configs: ConfigService
  ) {

  }


  initializeLanguage(): void {
    this.translate.setDefaultLang('en');

    /**
     set language at the initialization by going through these options
     - from localStorage: selected by user
     - from browser
     - from cloudflare
     - default: english
     */

    // const savedLang = localStorage.getItem('lang');
    let savedLang:string | null = null;
    try {
      if (typeof window !== 'undefined' && localStorage) {
        savedLang = localStorage.getItem('lang');
      }
    } catch (e) {
      console.warn('localStorage is not accessible:', e);
    }

    if(savedLang){
      // this.selectedLang = savedLang;
      // this.translate.use(savedLang);
      this.checkAndSetSelectedLanguage(savedLang);
    } else {
      if (navigator.language) {
        const lang = navigator.language.slice(0,2)
        this.checkAndSetSelectedLanguage(lang)
      } else {
        // no browser language available
        this.setLangFromCloudflare();
      }
    }
  }

  checkAndSetSelectedLanguage(lang:string): void {
    const isLanguageSupported = this.languageOptions.some(option => option.value === lang);
    if (isLanguageSupported){
      this.selectedLang = lang;
      //todo rtl design on core
      // if(this.configs.hasOnlyLandings){
      //   let htmlTag = this.document.getElementsByTagName('html')[0] as HTMLHtmlElement;
      //   htmlTag.dir = lang === 'ar' ? 'rtl' : 'ltr';
      // }
    } else {
      this.selectedLang = "en";
      // console.log(`${lang} is not supported. Defaulting to 'en'.`);
    }
    try {
      localStorage.setItem('lang', this.selectedLang);
    } catch (error) {
      console.warn('Error accessing localStorage:', error);
    }
    this.translate.use(this.selectedLang);
  }

  setLangFromCloudflare() {
    this.getUserLocationFromCloudflare().subscribe({
      next: (location: string)=> {
        const loc = location.toLowerCase()
        this.checkAndSetSelectedLanguage(loc)
      },
      error: err => {
        // console.error('Error fetching user location:', err);
        this.checkAndSetSelectedLanguage('en')
      }
    })
  }


  getUserLocationFromCloudflare(): Observable<string> {
    return this.http.get('https://www.cloudflare.com/cdn-cgi/trace', { responseType: 'text' }).pipe(
      map((response: string)=> {
        let data = response.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
        data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
        const jsonData = JSON.parse(data);
        return jsonData.loc;
      }),
      catchError(error => {
        // console.error('Error:', error);
        return of('else'); // Return a fallback value in case of error
      })
    )
  }

  setUserSelectedLang(language: string) {
    this.selectedLang = language;
    try {
      localStorage.setItem('lang', language ?? 'en');
    } catch (error) {
      console.warn('Error accessing localStorage:', error);
    }

    //todo rtl design on core
    if(this.configs.hasOnlyLandings){
      let htmlTag = this.document.getElementsByTagName('html')[0] as HTMLHtmlElement;
      htmlTag.dir = language === 'ar' ? 'rtl' : 'ltr';
    }
    this.translate.use(language);

    if (language === 'en') {
      //as translate.currentLang does not changes to english if we have different lang saved in localstorage: we have to set it manually:
      this.translate.reloadLang('en');
    }

  }





}


